import React from 'react';

export const ModuleAccess = (module, permission) => {
    var modules = {
         'CLNTDB': {
           'SUPADM':['VW', 'EDT'],
            'RxHLP': ['VW',],
            'RxHLPSUP':['VW', 'EDT'],
            'BFTCONF' :['VW', 'EDT'],
            'ENR' :['VW', 'EDT'],
            'NET' :['VW', 'EDT'],
            'FRML' :['VW', 'EDT'],
            'CLM' :['VW', 'EDT'],
            'OPS' :['VW', 'EDT'],
            'AM' :['VW'],
            'COMP':['VW'],
            'AM340B':['VW'],
            'PRX' :['VW', 'EDT'],
            'EXREV':['VW'],
            'EXEDT':['VW', 'EDT'],
            'IPS':['VW'],
            'EX340BREV' :['VW'],
            'EX340BEDT' :['VW', 'EDT'],
        }
    }

 const { access_token } =
        JSON.parse(localStorage.getItem('pharmaforce')) || {};
    let userRoles = [];
    if (access_token) {
        let jwtData = access_token.split('.')[1]
        let decodedJwtJsonData = window.atob(jwtData)
        let decodedJwtData = JSON.parse(decodedJwtJsonData)
        userRoles = decodedJwtData['roles'];
    }


    (module);
    var roles = modules[module];
    (roles);
    var permissions = [];
    if (Array.isArray(userRoles)) {
        for (var i = 0; i < userRoles.length; i++) {
            var userRole = userRoles[i];
            //(userRole);
            var userper = roles[userRole];
            //(userper);
            permissions = permissions.concat(userper);
        }
    }
    else {

        var userper = roles[userRoles];
        if (userper)
            permissions = permissions.concat(userper);
    }

    //(permissions);
    if (!permission)
        return permissions.length > 0;
    return permissions.indexOf(permission) != -1;
}